import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  showAboutMe=false;
  constructor() { }

  ngOnInit() {
  }

  setShowAboutMe(show){
    this.showAboutMe = show;
  }
  

}
